import { useMutation, useQuery } from "@apollo/client/react";
import { GQLQuery, GQLMutation } from "@rx-cs-system/schema";
import { useNavigate, useParams } from "react-router";

import { useHandleError } from "../../../hooks";
import { GET_SC_USER } from "../../../graphql/queries";
import { parsePatientSc } from "../../../graphql/utils";
import {
  PatientScDetailPage as Component,
  PatientProps,
} from "../../../components/pages/patientSc/PatientScDetailPage";
import { useSnackBar } from "../../../hooks/useSnackBar";
import { FORCE_CANCEL_PRESCRIPTION } from "../../../graphql/mutations";
import { useCheckUserRole } from "../../../hooks/useCheckUserRole";

export const PatientScDetailPage = () => {
  const navigate = useNavigate();
  useCheckUserRole();
  const { snackBar, showOKSnackBar } = useSnackBar();
  // @ts-ignore idが存在するのに「ない」と怒られるので
  const { id: patientId } = useParams();
  if (!patientId) throw new Error("patientId is undefined");

  const { error, data } = useQuery<GQLQuery>(GET_SC_USER, {
    variables: { id: patientId },
  });

  const [forceCancelPrescription] = useMutation<GQLMutation>(
    FORCE_CANCEL_PRESCRIPTION,
    {
      onCompleted: (result) => {
        if (
          result.forceCancelPrescription?.__typename ===
          "ForceCancelPrescriptionError"
        ) {
          navigate(`/cancelPrescription/error`, {
            state: {
              message: result.forceCancelPrescription.message,
              prescriptionCode: result.forceCancelPrescription.prescriptionCode,
            },
          });
        } else {
          showOKSnackBar("処方をキャンセルしました。");
        }
      },
      onError: () => {
        navigate(`/cancelPrescription/error`, {
          state: {
            prescriptionCode: data?.scUser.prescriptionCode,
          },
        });
      },
    },
  );

  useHandleError(error);

  if (!data?.scUser) {
    return null;
  }

  const handleCancelPrescriptionCodeButtonClick = async () => {
    const isOk = confirm(
      "本当に処方をキャンセルしますか？キャンセルしたら元には戻せません。",
    );
    if (isOk) {
      await forceCancelPrescription({
        variables: {
          input: {
            prescriptionCode: data?.scUser.prescriptionCode,
          },
        },
      });
    }
  };

  const props: PatientProps = {
    patient: parsePatientSc(data.scUser),
    onCancelPrescriptionCodeButtonClick:
      handleCancelPrescriptionCodeButtonClick,
    snackBar,
  };

  return <Component {...props} />;
};
